export default "__VITE_ASSET__ylmnBpRg__"